import { render, staticRenderFns } from "./DeliveryBillList.vue?vue&type=template&id=347afd6b&scoped=true&"
import script from "./DeliveryBillList.vue?vue&type=script&lang=js&"
export * from "./DeliveryBillList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryBillList.vue?vue&type=style&index=0&id=347afd6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347afd6b",
  null
  
)

export default component.exports